export enum ReportScope {
    Desks = 1,
    Categories,
    Users
}